import { useLocale } from '@gov-nx/core/service/translations/useLocale';
import { useDataBoxMessageFormContext } from '@gov-nx/module/data-box/providers/MessageFormContext';
import { PageCode } from '@gov-nx/module/page/definitions/codes';
import { FormListItem } from './FormListItem';

export const AdditionalDataList = () => {
	const { localData, hasAdditionalInfo, removeAdditionalData } =
		useDataBoxMessageFormContext();
	const { t: tn } = useLocale(PageCode['datove-schranky']);

	if (!hasAdditionalInfo) {
		return null;
	}

	return (
		<ul className="gov-list--plain flex gap-2 flex-wrap">
			{localData.intoTheirOwnHands ? (
				<FormListItem
					onRemoveClick={() => removeAdditionalData('intoTheirOwnHands')}>
					{tn('nova-zprava.doplnkove-udaje.do-vlastnich-rukou')}
				</FormListItem>
			) : null}
			{localData.senderIdentification ? (
				<FormListItem
					onRemoveClick={() => removeAdditionalData('senderIdentification')}>
					{tn('nova-zprava.doplnkove-udaje.pridat-identifikaci')}
				</FormListItem>
			) : null}
			{localData.toTheHandsOf ? (
				<FormListItem
					onRemoveClick={() => removeAdditionalData('toTheHandsOf')}>
					<span className="text-left">
						{tn('nova-zprava.doplnkove-udaje.k-rukam-osoby')}:{' '}
					</span>
					<strong className="break-all text-left">
						{localData.toTheHandsOf}
					</strong>
				</FormListItem>
			) : null}
			{localData.naseCisloJednaci ? (
				<FormListItem
					onRemoveClick={() => removeAdditionalData('naseCisloJednaci')}>
					<span className="text-left">
						{tn('nova-zprava.doplnkove-udaje.nase-cislo-jednaci')}:{' '}
					</span>
					<strong className="break-all text-left">
						{localData.naseCisloJednaci}
					</strong>
				</FormListItem>
			) : null}
			{localData.naseSpisovaZnacka ? (
				<FormListItem
					onRemoveClick={() => removeAdditionalData('naseSpisovaZnacka')}>
					<span className="text-left">
						{tn('nova-zprava.doplnkove-udaje.nase-spisova-znacka')}:{' '}
					</span>
					<strong className="break-all text-left">
						{localData.naseSpisovaZnacka}
					</strong>
				</FormListItem>
			) : null}
			{localData.vaseCisloJednaci ? (
				<FormListItem
					onRemoveClick={() => removeAdditionalData('vaseCisloJednaci')}>
					<span className="text-left">
						{tn('nova-zprava.doplnkove-udaje.vase-cislo-jednaci')}:{' '}
					</span>
					<strong className="break-all text-left">
						{localData.vaseCisloJednaci}
					</strong>
				</FormListItem>
			) : null}
			{localData.vaseSpisovaZnacka ? (
				<FormListItem
					onRemoveClick={() => removeAdditionalData('vaseSpisovaZnacka')}>
					<span className="text-left">
						{tn('nova-zprava.doplnkove-udaje.vase-spisova-znacka')}:{' '}
					</span>
					<strong className="break-all text-left">
						{localData.vaseSpisovaZnacka}
					</strong>
				</FormListItem>
			) : null}
		</ul>
	);
};
